import { PauseIcon, PlayIcon } from '@heroicons/react/24/solid';
import { useAppDispatch, useAppSelector } from '../../stores/store';
import { playerActions } from './playerSlice';
import { ExclamationCircleIcon, SpeakerWaveIcon } from '@heroicons/react/24/outline';
import { useContext } from 'react';
import { AppMainStateContext } from '../../contexts/AppMainStateContext.tsx';
import { Orientation } from '../../consts/orientation.ts';

export const PlayerUIControl = () => {
    const dispatch = useAppDispatch();
    const playerErrorStatus = useAppSelector((state) => state.player.errorStatus);
    const isPlaying = useAppSelector((state) => state.player.playing);
    const isBuffer = useAppSelector((state) => state.player.isBuffer);
    const isInitialRun = useAppSelector((state) => state.player.initialRun);
    const isMenuUIVisible = useAppSelector((state) => state.playerUI.isMenuUIVisible);
    const { isIOS, orientation, isMobile } = useContext(AppMainStateContext);

    const getTopPositionValue = (): string => {
        if ((isMobile && orientation === Orientation.LANDSCAPE_PRIMARY) || !isMobile) {
            return '50%';
        }
        return window.innerWidth / 16 * 4 + 'px';
    };

    return (
        <>
            <div
                className={`absolute md:top-1/2 md:-translate-y-1/2 left-1/2 -translate-x-1/2 flex flex-col z-10 ${isIOS && !playerErrorStatus && 'hidden'}`}
                style={{ top: getTopPositionValue() }}
            >
                {isBuffer && !playerErrorStatus && !isIOS &&
                    <div
                        className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-e-transparent align-[-0.125em] text-surface motion-reduce:animate-[spin_1.5s_linear_infinite] dark:text-white"
                        role="status"
                    >
                        <span
                            className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">
                            Loading...
                        </span>
                    </div>
                }
                {!isBuffer && playerErrorStatus &&
                    <div className={'flex flex-col items-center select-none space-y-1'} role={'alert'}>
                        <ExclamationCircleIcon className={'w-11 h-11'} aria-hidden="true" />
                        <div className="text-center">
                            <h3 className="text-lg font-semibold text-white">
                                {playerErrorStatus.title}
                            </h3>

                            {playerErrorStatus.description && (
                                <p className="text-sm text-gray-400 mt-1 max-w-sm mx-auto">
                                    {playerErrorStatus.description}
                                </p>
                            )}
                        </div>
                    </div>
                }
                {!playerErrorStatus && !isBuffer && !isInitialRun && !isIOS &&
                    <button
                        id={'playPauseBtn'}
                        className={`focus:outline-none ${isMenuUIVisible ? 'opacity-100' : 'opacity-0 md:opacity-100'} transition-opacity`}
                        onClick={() => dispatch(playerActions.togglePlaying())}
                    >
                        {!playerErrorStatus && isPlaying ?
                            <PauseIcon className={'w-12 h-12'} />
                            :
                            <PlayIcon className={'w-12 h-12'} />
                        }
                    </button>
                }
                {!playerErrorStatus && !isBuffer && isInitialRun && !isIOS &&
                    <button
                        className={'focus:outline-none flex flex-col items-center -mt-5 md:mt-0'}
                        onClick={() => dispatch(playerActions.setInitialRun(false))}
                    >
                        <SpeakerWaveIcon className="w-12 h-12 mb-2" />
                        Kliknij tutaj aby włączyć dźwięk
                    </button>
                }
            </div>
        </>
    );
};